import { useQuery } from 'react-query';

//consts
import { QUERY_KEYS } from 'consts/queryKeys';

//services
import { confirmUserRegistration } from '../api';

export const useQueryLogin = ({ id }) => {
  const { error } = useQuery(
    [QUERY_KEYS.RENTALS_USER_REGISTRATION, id],
    () => confirmUserRegistration(id),
    {
      retry: false,
    },
  );

  return { error };
};
